export const TICKETS = {
  newTicketButton: "tickets-new-ticket-button",
  listView: "tickets-list-view",
  kanbanView: "tickets-kanban-view",
  searchInput: "tickets-search-input",
  statusFilter: "tickets-status-filter",
  priorityFilter: "tickets-priority-filter",
  row: "tickets-row",
  ticketDetail: "ticket-detail",
  statusDropdown: "ticket-status-dropdown",
  priorityDropdown: "ticket-priority-dropdown",
  assigneeDropdown: "ticket-assignee-dropdown",
  replyBox: "ticket-reply-box",
  replySubmit: "ticket-reply-submit",
  internalToggle: "ticket-internal-toggle",
  aiSuggestButton: "ticket-ai-suggest-button",
  createDialog: "ticket-create-dialog",
  createSubmit: "ticket-create-submit",
};

export const INBOX = {
  list: "inbox-list",
  emailRow: "inbox-email-row",
  convertButton: "inbox-convert-button",
};

export const KB = {
  newArticleButton: "kb-new-article-button",
  articleCard: "kb-article-card",
  createSubmit: "kb-create-submit",
};

export const NAV = {
  sidebarDashboard: "nav-dashboard",
  sidebarTickets: "nav-tickets",
  sidebarInbox: "nav-inbox",
  sidebarKb: "nav-kb",
  sidebarSettings: "nav-settings",
  userMenu: "nav-user-menu",
  logoutButton: "nav-logout-button",
};
